module.exports = __webpack_public_path__ + "img/winter_woolies.09194104.png";